module.exports = __webpack_public_path__ + "img/VERS2.7451ee55.png";